import { render, staticRenderFns } from "./StarpassPick.vue?vue&type=template&id=282ae30d&scoped=true"
import script from "./StarpassPick.vue?vue&type=script&lang=js"
export * from "./StarpassPick.vue?vue&type=script&lang=js"
import style0 from "./StarpassPick.vue?vue&type=style&index=0&id=282ae30d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ae30d",
  null
  
)

export default component.exports